// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ms-6";
export var imgContainer = "_ms-3";
export var menuIcon = "_ms-5";
export var pillWrapper = "_ms-2";
export var pillsContainer = "_ms-1";
export var subscriptionCard = "_ms-0";
export var subscriptionLogo = "_ms-4";